<template>
    <div class="card-box p-0 m-0">
        <div class="over_auto">
            <table class="table table-striped table-bordered m-0">
                <thead>
                    <tr>
                        <th class="t_center max_w_100">{{ $t('created_at') }}</th>
                        <th class="t_center max_w_100">{{ $t('sold_at') }}</th>
                        <th class="t_center max_w_120">{{ $t('consultant') }}</th>
                        <th class="t_center max_w_120">{{ $t('source') }}</th>
                        <th class="t_center max_w_120">{{ $t('segment') }}</th>
                        <th colspan="2" class="max_w_180">{{ $t('deal') }}</th>
                        <th class="t_center">{{ $t('total') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in records" :key="item.id">
                        <td class="t_center">
                            <small class="show" >{{ item.deal.created_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                        </td>
                        <td class="t_center">
                            <small class="show" >{{ item.deal.closed_at | pmlDate('DD/MM/YYYY HH:mm') }}</small>
                        </td>
                        <td class="t_center">
                            {{ item.member_id | pmlMemberById }}
                        </td>
                        <td class="t_center">
                            <span v-if="item.deal.source_id" class="label label-default" :style="`background-color: ${getSourceColor(item.deal.source_id)};`">{{ item.deal.source_id | pmlSourceById }}</span>
                            <span class="label label-disabled" v-else>N/A</span>
                        </td>
                        <td class="t_center">
                            <span v-if="item.deal.segment_id" class="label label-default" :style="`background-color: ${getSegmentColor(item.deal.segment_id)};`">{{ item.deal.segment_id | pmlSegmentById }}</span>
                            <span class="label label-disabled" v-else>N/A</span>
                        </td>
                        <td class="max_w_50 b_r_none">
                            <img class="img-circle thumb-sm" :src="item.deal.lead.avatar || `/static/images/avatar.jpg`" v-pml-tooltip.top-right="item.deal.lead.name">
                        </td>
                        <td class="bold p-l-0">
                           <router-link :to="{ name: 'deals.show', params: { id: item.deal.id } }">
                               {{ `#${item.deal.code} - ${item.deal.lead.name}` }}
                           </router-link>
                        </td>
                        <td class="t_center">
                           {{ (item.total_products + item.total_taxes - item.total_discounts) | pmlCurrency(symbol(item.currency_id)) }}
                        </td>
                    </tr>
                    <tr v-show="!records.length">
                        <td class="t_center" colspan="9"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'QuotationsList',
        props: ['records'],
        methods: {
            symbol (id) {
                let currency = this.$options.filters.pmlCurrencyById(id, 'symbol')
                if (currency)
                    return currency.symbol

                return ''
            },
            getSourceColor (id) {
                return this.$options.filters.pmlSourceById(id, 'color')
            },
            getSegmentColor (id) {
                return this.$options.filters.pmlSegmentById(id, 'color')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/sales/components/List.vue